const CreateBillingObject = (country = 'NZ', email, billingInformation) => {
	const {
		salutation = '',
		addressType = '',
		firstName,
		lastName,
		companyName = '',
		address1,
		address2 = '',
		address3 = null,
		dayPhoneNumber,
		phoneNumber,
		city,
		postalCode,
		stateCode,
	} = billingInformation;

	let finalAddressType = addressType
		? addressType
		: companyName.length > 0
		? 'Commercial'
		: 'Residential';

	let billingObject = {
		contactInfo: {
			deliveryPhoneNumber: dayPhoneNumber || phoneNumber,
			email: email,
			companyName: companyName,
			dayPhoneNumber: dayPhoneNumber || phoneNumber,
		},
		address: {
			address1,
			address2,
			address3,
			city,
			country,
			postalCode,
			type: country,
			addressType: finalAddressType,
		},
		personalInfo: {
			salutation,
			firstName,
			lastName,
		},
	};

	if (country === 'AU') {
		billingObject = {
			...billingObject,
			address: { ...billingObject.address, state: stateCode, stateCode },
		};
	}

	return billingObject;
};

export default CreateBillingObject;
